import React, { ElementType } from 'react';

import { Animation } from '@types';

export type PageRenderTransition = {
  name: Animation;
  delay?: number;
  classNames?: string;
};

export interface Field {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface FlexibleData {
  schema: SchemaItem[];
  fields: {
    [key: string]: Field;
  };
}

export interface SchemaItem {
  showField: boolean;
  name: string;
  id: string;
  type: string;
  config: string;
  required: boolean;
}

interface RenderConfigProps {
  config: string;
  fields: Field;
  errorFallback?: ElementType;
  renderers: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [configType: string]: React.FC<any>;
  };
  transition?: PageRenderTransition;
  params: {
    venue?: string;
    domain: string;
  };
  id?: string;
}

export function BlockRender({
  config,
  fields,
  id,
  params,
  renderers,
  errorFallback: ErrorFallback,
  transition,
}: RenderConfigProps) {
  if (!config) {
    return null;
  }

  const Renderer = renderers[config];

  if (!Renderer) {
    console.error(`No renderer found for config type: ${config}`);
    return null;
  }

  if (!params) {
    console.error('No params provided to BlockRender');
    return null;
  }

  try {
    return <Renderer {...fields} id={id} params={params} transition={transition} />;
  } catch (error) {
    console.error(`Error rendering block: ${config}`, error);
    return ErrorFallback ? <ErrorFallback /> : null;
  }
}
